import {
  useQueryClient,
  useMutation,
  UseMutationResult,
} from '@tanstack/react-query'
import { getUseSoundRecordsKey, useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { APIErrorResponse, PostSoundRecord, SoundRecord } from '@/types'

export const usePostSoundRecord = (
  id: number
): UseMutationResult<SoundRecord, APIErrorResponse, PostSoundRecord> => {
  const client = useApiClient()
  const queryClient = useQueryClient()

  return useMutation(
    async (params) => {
      const formData = new FormData()

      formData.append('analysis_status', params.analysis_status)
      formData.append('reject_reason', params.reject_reason)
      formData.append('second_opinion_reason', params.second_opinion_reason)

      if (params.spectrogram_link) {
        formData.append('spectrogram_link', params.spectrogram_link)
      }

      formData.append('specie_identified', params.specie_identified)
      formData.append('analysis_notes', params.analysis_notes)
      formData.append(
        'analysis_confidence',
        params.analysis_confidence ? params.analysis_confidence.toString() : ''
      )

      return client
        .post(`/plannings/sound_recordings/${id}/save_analysis/`, formData)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse)
    },
    {
      onSuccess: async () => {
        const queryKey = getUseSoundRecordsKey()

        await queryClient.invalidateQueries(queryKey)
      },
    }
  )
}
